import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

interface RawChange {
  ActionDate: string;
  changedBy: "user" | "patient";
  OldValues?: string;
  NewValues?: string;
  oldExamTypeName?: string;
  newExamTypeName?: string;
  oldDocName?: string;
  newDocName?: string;
  oldRoomName?: string;
  newRoomName?: string;
  performedByName?: string;
}

interface DisplayChange {
  actionDate: Date;
  changedBy: "user" | "patient";
  oldValue: any;
  newValue: any;
  performedByName?: string;
}

@Component({
    selector: "app-appointment-changes-dialog",
    templateUrl: "./appointment-changes-dialog.component.html",
    standalone: false
})
export class AppointmentChangesDialogComponent implements OnInit {
  public displayChanges: DisplayChange[] = [];
  public field: string;
  public isDateField = false;
  public isExamField = false;
  public isCompletedField = false;
  public isArrivalConfirmedField = false;
  public isDoctorField = false;
  public isRoomField = false;

  constructor(
    public dialogRef: MatDialogRef<AppointmentChangesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { changes: RawChange[]; field: string }
  ) {
    this.field = data.field;
    this.isDateField = this.field === "aptTime";
    this.isExamField = this.field === "examTypeID";
    this.isCompletedField = this.field === "completed";
    this.isArrivalConfirmedField = this.field === "arrivalConfirm";
    this.isDoctorField = this.field === "DocUID";
    this.isRoomField = this.field === "RID";
  }

  ngOnInit() {
    for (const change of this.data.changes) {
      const dc: DisplayChange = {
        actionDate: new Date(change.ActionDate),
        changedBy: change.changedBy,
        oldValue: null,
        newValue: null,
        performedByName: change.performedByName ?? null,
      };

      if (this.isDateField) {
        if (change.OldValues && change.NewValues) {
          try {
            const oldV = JSON.parse(change.OldValues);
            const newV = JSON.parse(change.NewValues);
            dc.oldValue = oldV[this.field];
            dc.newValue = newV[this.field];
          } catch {}
        }
      } else if (this.isExamField) {
        dc.oldValue = change.oldExamTypeName ?? null;
        dc.newValue = change.newExamTypeName ?? null;
      } else if (this.isCompletedField) {
        try {
          const oldV = JSON.parse(change.OldValues || "{}");
          const newV = JSON.parse(change.NewValues || "{}");
          dc.oldValue = oldV[this.field];
          dc.newValue = newV[this.field];
        } catch {}
      } else if (this.isArrivalConfirmedField) {
        try {
          const oldV = JSON.parse(change.OldValues || "{}");
          const newV = JSON.parse(change.NewValues || "{}");
          dc.oldValue = oldV[this.field];
          dc.newValue = newV[this.field];
        } catch {}
      } else if (this.isDoctorField) {
        dc.oldValue = (change as any).oldDocName ?? null;
        dc.newValue = (change as any).newDocName ?? null;
      } else if (this.isRoomField) {
        dc.oldValue = (change as any).oldRoomName ?? null;
        dc.newValue = (change as any).newRoomName ?? null;
      } else {
        if (change.OldValues && change.NewValues) {
          try {
            const oldV = JSON.parse(change.OldValues);
            const newV = JSON.parse(change.NewValues);
            dc.oldValue = oldV[this.field];
            dc.newValue = newV[this.field];
          } catch {}
        }
      }

      this.displayChanges.push(dc);
    }
  }
}
